export default {
}



// WEBPACK FOOTER //
// ./~/vue-components/live-coach/store/actions.js